import { render } from "./HomeStats.vue?vue&type=template&id=358a2b7c&scoped=true"
import script from "./HomeStats.vue?vue&type=script&lang=js"
export * from "./HomeStats.vue?vue&type=script&lang=js"

import "./HomeStats.vue?vue&type=style&index=0&id=358a2b7c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-358a2b7c"

export default script